import { Button, Image, Modal } from '@skupreme/shared/ui';
import CatalogService from '@utility/services/catalog';
import { ToastMessage } from '@utility/toast';
import { useState } from 'react';
import { ItemIdentifier } from '../table/ItemIdentifier';

export type ResyncItem = {
  _id: string;
  p_title?: string;
  p_sku?: string;
  p_images?: { display_image?: string };
  variation_images?: string[];
  marketplaces?: { tiktok?: { _id?: string } } | null;
};

/** Sends one listing to TikTok again. */
export function ResyncModal({
  item,
  onClose,
}: {
  item: ResyncItem | null;
  onClose: () => void;
}) {
  const [saving, setSaving] = useState(false);

  const resync = async () => {
    if (!item) return;
    try {
      setSaving(true);
      await CatalogService.insertItem({
        itemId: item._id,
        marketplaceId: item.marketplaces?.tiktok?._id,
      });
      ToastMessage.success('Item resynced successfully');
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={!!item}
      onOpenChange={open => !open && onClose()}
      title="Confirm resync to TikTok"
      size="md"
      footer={
        <>
          <Button variant="ghost" onPress={onClose} isDisabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onPress={resync} isDisabled={saving}>
            Confirm
          </Button>
        </>
      }
    >
      <div className="sk:flex sk:items-center sk:gap-3">
        <Image
          src={item?.variation_images?.[0] ?? item?.p_images?.display_image}
          alt=""
          size="md"
          fit="contain"
        />
        <div className="sk:flex sk:min-w-0 sk:flex-col sk:gap-1">
          <span className="sk:text-sm sk:text-fg">{item?.p_title}</span>
          {item?.p_sku ? (
            <ItemIdentifier label="SKU" value={item.p_sku} />
          ) : null}
        </div>
      </div>
    </Modal>
  );
}
